module.exports = __webpack_public_path__ + "img/38_59.6126acf2.png";